import { render, staticRenderFns } from "./YouHaveTheControl.vue?vue&type=template&id=2b50498d&scoped=true"
import script from "./YouHaveTheControl.vue?vue&type=script&lang=js"
export * from "./YouHaveTheControl.vue?vue&type=script&lang=js"
import style0 from "./YouHaveTheControl.vue?vue&type=style&index=0&id=2b50498d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50498d",
  null
  
)

export default component.exports